import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Phone, Mail, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function MessagesAdmin() {
  const qc = useQueryClient();
  const { data: messages = [], isLoading } = useQuery({ queryKey: ["admin-messages"], queryFn: () => api.get("/admin/messages").then((r) => r.data) });
  const del = useMutation({ mutationFn: (id) => api.delete(`/admin/messages/${id}`), onSuccess: () => { qc.invalidateQueries({ queryKey: ["admin-messages"] }); toast.success("Deleted"); } });
  return (
    <div data-testid="admin-messages">
      <h1 className="text-2xl font-heading font-bold text-navy-heading mb-1">Contact Messages</h1>
      <p className="text-slate-500 text-sm mb-6">Messages submitted through the contact form.</p>
      {isLoading ? <div className="text-slate-400">Loading…</div> :
        messages.length === 0 ? <div className="bg-white rounded-2xl border border-slate-100 p-10 text-center text-slate-400">No messages yet.</div> :
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {messages.map((m) => (
            <div key={m.id} className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5">
              <div className="flex items-start justify-between">
                <div>
                  <div className="font-semibold text-navy-heading">{m.name}</div>
                  <div className="flex items-center gap-3 text-xs text-slate-500 mt-1">
                    <a href={`tel:${m.phone}`} className="flex items-center gap-1 hover:text-brand"><Phone className="w-3 h-3" /> {m.phone}</a>
                    {m.email && <a href={`mailto:${m.email}`} className="flex items-center gap-1 hover:text-brand"><Mail className="w-3 h-3" /> {m.email}</a>}
                  </div>
                </div>
                <button onClick={() => del.mutate(m.id)} className="text-red-500 hover:bg-red-50 p-2 rounded-lg"><Trash2 className="w-4 h-4" /></button>
              </div>
              {m.message && <p className="mt-3 text-sm text-slate-600 leading-relaxed">{m.message}</p>}
              <div className="mt-2 text-xs text-slate-400">{new Date(m.created_at).toLocaleString()}</div>
            </div>
          ))}
        </div>}
    </div>
  );
}
